module.exports = __webpack_public_path__ + "merge_slight_right.svg?951b644b750cc13190f3be78c10c8831";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/merge_slight_right.svg
// module id = 180
// module chunks = 0